export default __webpack_public_path__ + "static/1-ac287db1d1ce2d136f7e6655ef932f33.png";